import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUSES } from "@/lib/status";

export const StatusBadge = ({ status, testid }) => {
  const s = STATUSES.find((x) => x.key === (status || "enquiry"));
  return <span className={`inline-block rounded border px-2 py-0.5 text-xs font-medium ${s.cls}`} data-testid={testid}>{s.label}</span>;
};

export const StatusSelect = ({ value, onChange, testid }) => (
  <Select value={value || "enquiry"} onValueChange={onChange}>
    <SelectTrigger className="h-8 w-[136px] bg-white text-xs" data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>
      {STATUSES.map((s) => <SelectItem key={s.key} value={s.key} data-testid={`${testid}-opt-${s.key}`}>{s.label}</SelectItem>)}
    </SelectContent>
  </Select>
);
